import React, { useState } from "react";
import classNames from "classnames";

const TimePicker = ({
  text,
  placeholder,
  otherMealName,
  mealName,
  isCompulsary,
}) => {
  const [isInputClicked, setIsInputClicked] = useState(false);
  const asteric = <span style={{ color: "red" }}>*</span>;

  const labelText =
    isInputClicked && !mealName
      ? `${placeholder}${asteric.props.children}`
      : `${placeholder}*`;

  const handleInputChange = (event) => {
    if (isCompulsary) setIsInputClicked(true);
    const { value } = event.target;
    const nonNumericValue = value.replace(/[0-9]/g, ""); // Don't allow numeric values

    otherMealName(nonNumericValue);
  };

  return (
    <div className="w-full screen-lg:w-[586px] screen-md:w-[586px] h-full px-2 py-4 bg-slate-50 rounded-lg flex-col justify-start items-start gap-2.5 inline-flex">
      <label
        className={`text-gray-800 ${
          isCompulsary ? "text-xl" : "text-base"
        } text-base font-inter-semibold leading-tight`}
      >
        {text}
      </label>

      <input
        type="text"
        id="otherMeal"
        className={classNames(
          "w-full screen-lg:w-[512px] screen-md:w-[512px] h-[46px] p-4 rounded-xl text-base font-inter-medium leading-7", // Static classes
          {
            "text-slate-700": mealName,
            "text-zinc-200": !mealName,
            "outline-red-400": isCompulsary && isInputClicked && !mealName,
          }
        )}
        placeholder={isCompulsary ? labelText : placeholder}
        value={mealName}
        onChange={handleInputChange}
      />

      {isCompulsary && isInputClicked && !mealName && (
        <div className="px-4 text-red-400 text-xs font-inter-medium leading-[14px]">
          This field needs to be filled
        </div>
      )}
    </div>
  );
};

export default TimePicker;
